<template>
  <vx-card ref="whole_page" v-show="isCardActiveLocal" title="Upload Task Details" class="mb-4">
    <div class="vx-row">
      <div class="vx-col w-full">
        <table>
          <tr><td><p>Title:</p></td><td><p style="font-weight: 700">{{ uploadTaskTitle }}</p></td></tr>
          <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{ uploadTaskContent }}</p></td></tr>
          <tr><td><p>Allow Multiple Uploads:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowMultiple), 'font-weight': 700 }">{{ uploadTask.allowMultiple ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Audio:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowAudio), 'font-weight': 700 }">{{ uploadTask.allowAudio ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Documents:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowDocument), 'font-weight': 700 }">{{ uploadTask.allowDocument ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Images:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowImage), 'font-weight': 700 }">{{ uploadTask.allowImage ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Videos:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowVideo), 'font-weight': 700 }">{{ uploadTask.allowVideo ? 'Yes' : 'No' }}</p></td></tr>
        </table>
      </div>
    </div>
    <vs-divider></vs-divider>
    <vs-table v-if="!reupload" ref="uploadsTable" single max-items="15" pagination :data="uploadTask.uploadedFiles">
      <div slot="header" class="mt-4 mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <h5>Uploaded Files</h5>
        </div>
      </div>

      <template slot-scope="{data}">
        <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
          <vs-td>
            <img :src="setFileThumb(file)" width=30px class="product-img" />
          </vs-td>
          <vs-td>
            <p class="product-name font-medium">{{ file.substring(file.lastIndexOf('/') + 1) }}</p>
          </vs-td>
          <vs-td class="float-right">
            <div class="flex flex-row">
              <vs-button color="warning" v-if="uploadTask.statusId == 1"  class="mr-2"  type="filled" icon-pack="feather" icon="icon-edit" @click.stop="reUploadFile(file,indextr)"></vs-button>
              <vs-button color="success" class="mr-2"  type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile(file)"></vs-button>
              <vs-button v-if="uploadTask.uploadedFiles.length > 1 && uploadTask.statusId == 1" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" @click.stop="areyousurePopup(file)"></vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="replace_buttons" v-if="uploadTask.allowMultiple && uploadTask.statusId == 1">
      <vs-button icon-pack="feather" icon="icon-plus" color="success" class="mb-2" type="border" v-if="!addnewFile && !reupload" @click="addnewFile = true;" >Add new</vs-button>
    </div>
      <div id="reuploadArea" ref="reuploadArea" v-if="reupload" class="w-full mb-6 pb-6">
        <div id="ReplaceFileName">
          <h5>Replace file :</h5>
          <h5>{{fileName}}</h5>
        </div>
        <div v-if="reupload" class="vx-row">
          <div  class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mx-auto  self-center">
            <file-pond
              v-show="true"
              id="cover-filepond"
              ref="newUploadPond"
              allowPaste=false
              :server="uploadLocation"
              label-idle="Upload new file here"
              :accepted-file-types="types"
              :allow-multiple="false"
              :allow-image-preview="false"
              :instant-upload="true"
              @processfile="newDocumentUploadComplete"
              @removefile="fileRemoved"
            />
          </div>
        </div>
        <div id="replace_buttons" class="vx-col pb-1 mb-1">
          <vs-button :disabled="replaceData.newFileUrl.length == 0" class="mr-2 mb-2" color="success" type="filled" @click.stop="displayPopup" >Save & Replace</vs-button>
          <vs-button  color="warning" type="border" @click.stop="closeReplace" >Cancel</vs-button>
        </div>
      </div>

      <div id="reuploadArea" ref="reuploadArea" v-if="addnewFile" class="w-full mb-6 pb-6">
        <div  id="ReplaceFileName">
          <h5>New file:</h5>
        </div>
        <div v-if="addnewFile" class="vx-row">
          <div  class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mx-auto  self-center">
            <file-pond
              v-show="true"
              id="cover-filepond"
              ref="newUploadPond"
              allowPaste=false
              :server="uploadLocation"
              label-idle="Upload new file here"
              :accepted-file-types="types"
              :allow-multiple="false"
              :allow-image-preview="false"
              :instant-upload="true"
              @processfile="newFileComplete"
              @removefile="newfileRemoved"
            />
          </div>
        </div>
        <div id="replace_buttons" class="vx-col pb-1 mb-1">
          <vs-button :disabled="newFileUrl.length == 0" class="mr-2 mb-2" color="success" type="filled" @click.stop="saveNewFile" >Save</vs-button>
          <vs-button  color="warning" type="border" @click.stop="addnewFile = false;" >Cancel</vs-button>
        </div>
      </div>

      <div v-if="!viewOnly">
        <vs-divider></vs-divider>
        <div class="vx-row">
          <div class="vx-col w-1/3 mx-auto  self-center">
            <file-pond
              v-show="true"
              id="cover-filepond"
              ref="newUploadPond"
              allowPaste=false
              :server="uploadLocation"
              label-idle="Upload new file here"
              :accepted-file-types="types"
              :allow-multiple="true"
              :allow-image-preview="false"
              :instant-upload="true"
              @processfile="uploadComplete"
              @removefile="removeReplacedUpload"
            />
          </div>
        </div>
      </div>
  </vx-card>
</template>

<script>

  import vSelect from 'vue-select'
  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
  import 'animate.css';

  export default {
    components: {
      'v-select': vSelect,
      FilePond
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      uploadTask: {
        type: Object,
        required: false
      },
      viewOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        uploadTaskTitle: "",
        uploadTaskContent: "",
        types: [],
        reupload: false,
        fileName:"",
        selectedFile:null,
        replaceData:{
          replaceFileUrl:"",
          newFileUrl:"",
          logId:0,
        },
        selectedIndex:0,
        addnewFile:false,
        newFileUrl:"",
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          var self=this;
          if(self.uploadTask){
            if (self.uploadTask.allowAudio)
              self.types.push("audio/mp3");
            if (self.uploadTask.allowDocument)
              self.types.push("application/pdf","application/msword", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain", "text/html","application/msaccess","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation");
            if (self.uploadTask.allowImage)
              self.types.push("image/png", "image/jpg", "image/jpeg", "image/gif");
            if (self.uploadTask.allowVideo)
              self.types.push("video/mp4", "video/mov", "video/wmv");
          }

          self.types = self.types;

          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          }else{
            self.initValues();
          }
        }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setColor(val) {
        if(val){
          return '#00cc00';
        }
        else{
          return 'orange';
        }
      },
      open(file){
        window.open(file,'_blank');
      },
      initValues(){
        var self = this;
        self.replaceData.newFileUrl = "";
        self.replaceData.replaceFileUrl = "";
        self.reupload = false;
        self.fileName = "";
        self.selectedFile = null;
        self.selectedIndex = 0;
      },
      setFileThumb(url) {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        this.errors.clear();
      },
      uploadComplete(error, file) {
        var self = this;
        var response = JSON.parse(file.serverId);
        if(response.url)
          this.uploadTask.newUploadedFiles.push(response.url);

        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "New File Saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-video',
        });  
      },
      fileRemoved(error, file) {
        this.formData.uploadedFileName = "";
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      downloadFile(file){
        window.open(file,'_blank');
      },
      reUploadFile(file, indextr){
        var self = this;
        this.replaceData.newFileUrl="";
        self.reupload = true;
        self.selectedFile = file;
        self.selectedIndex = indextr;
        self.fileName = file.substring(file.lastIndexOf('/') + 1);
      },
      closeReplace(){
        this.reupload = false;
        this.initValues();
      },
      replaceFile(){
        var self = this;
        self.replaceData.replaceFileUrl = self.selectedFile;
        self.replaceData.logId = self.$route.query.TaskLogId;
        self.showLoadingOnElement('reuploadArea',1.0,'material');

        var onSuccess = response =>{
          if(self.$refs.reuploadArea){
            self.$vs.loading.close(self.$refs.reuploadArea.$el);
          }
          self.$swal.fire('File Replaced', '', 'success')
          .then((result)=> {
            self.$emit('initValues');
            self.$emit('loadTask');
          });
        }
      
        var onFinally = response =>{
          if(self.$refs.reuploadArea){
            self.$vs.loading.close(self.$refs.reuploadArea.$el);
          }
          self.reupload = false;
        }
        
        self.$ajaxPost(self, "Document/ReplaceFile" , self.replaceData , onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      newDocumentUploadComplete(error, file) {
        var self = this;
        var response = JSON.parse(file.serverId);
        if(response.url)
          this.replaceData.newFileUrl = response.url;

        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "New File Saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-video',
        });  
      },
      removeReplacedUpload(error, file) {
        this.replaceData.newFileUrl = "";
      },
      displayPopup(){
        var self = this;
        self.$swal({
          title: 'Do you want to save the changes?',
          text:'Original file will be deleted and replaced with the new file',
          showDenyButton: true,
          confirmButtonText: 'Save & Replace',
          denyButtonText: `Don't save`,
        }).then((result) => {
          if (result.isConfirmed) {
            self.replaceFile();
          } else if (result.isDenied) {
            self.$swal.fire('Changes are not saved', '', 'info')
          }
        });
      },
      deleteFile(file){
        var self = this;
        self.replaceData.replaceFileUrl = file;
        self.replaceData.logId = self.$route.query.TaskLogId;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
          self.$swal.fire('File Removed', '', 'error')
          .then((result)=> {
            self.$emit('initValues');
            self.$emit('loadTask');
          });
        }
      
        var onFinally = response =>{
          if(self.$refs.ref){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxPost(self, "Document/RemoveUploadTaskFile" , self.replaceData , onSuccess, onFinally);
      },
      areyousurePopup(file){
        var self = this;
        self.$swal({
          title: `Do you want to Remove ?`,
          text:`${file.substring(file.lastIndexOf('/') + 1)}`,
          showDenyButton: true,
          confirmButtonText: 'Delete',
          denyButtonText: `Cancel`,
        }).then((result) => {
          if (result.isConfirmed) {
            self.deleteFile(file);
          } else if (result.isDenied) {
            self.$swal.fire('File not removed', '', 'info')
          }
        });
      },
      newFileComplete(error, file) {
        var self = this;
        var response = JSON.parse(file.serverId);
        if(response.url)
          this.newFileUrl = response.url;

        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "New File Saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-video',
        });  
      },
      newfileRemoved(error, file) {
        this.newFileUrl = "";
      },
      saveNewFile(){
        var self = this;
        self.showLoadingOnElement("reuploadArea",1,"corners");
        self.replaceData.newFileUrl = self.newFileUrl;
        self.replaceData.logId = self.$route.query.TaskLogId;

        var onSuccess = response =>{
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "New File Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-video',
          });  
        }
      
        var onFinally = response =>{
          if(self.$refs.reuploadArea){
            self.$vs.loading.close(self.$refs.reuploadArea.$el);
            self.$emit('initValues');
            self.$emit('loadTask');
          }
        }
      
        self.$ajaxPost(self, "Document/AddNewUploadTaskFile" , self.replaceData , onSuccess, onFinally);
      },
    },
    mounted() {
      if(this.uploadTask){
        this.uploadTaskTitle = this.strip(this.uploadTask.title);
        this.uploadTaskContent = this.strip(this.uploadTask.content);
      }
      this.initValues();
    }
  }

</script>

<style lang="scss">
#reuploadArea{
 
  #cover-filepond .filepond--drop-label > label, #book-filepond .filepond--drop-label > label, #video-filepond .filepond--drop-label > label, #podcast-filepond .filepond--drop-label > label{
    color: black !important;
    cursor: pointer;
  }
  .filepond--wrapper{
    cursor: pointer;
  }
  
}
#replace_buttons{
  float: right;
  padding-bottom: 30px;
}
@media screen and (max-width: 644px) {
  #replace_buttons ,.replace_buttons {
    width: 100%;
    button{
      margin: auto;
      width: 100%;
      padding: 8px !important;
    }
  }
  #reuploadArea{
    display: inline-block;
  }
}
</style>
